import React, { FC, useEffect, useState } from 'react';
import { Utilities } from '@utils';
import AEABatchGrid, { BatchGridColumnProps } from '@/components/ui/aea-batch-grid/aea-batch-grid';
import { TableByProjectPresenter, ITableByProject } from '@presenters/screens/table-by-project.presenter';
import "../table-by-project/table-by-project.module.scss";

const FormBudgetDetailTableByProject: FC<any> = () => {
    const [columns, setColumns] = useState<BatchGridColumnProps[]>([]);
    const [data, setData] = useState<any>([]);
    const [readOnly, setReadOnly] = useState(false);
    const [modalExcel, setModalExcel] = useState<boolean>(false);

    let view: ITableByProject = {
        state: {
            columns,
            setColumns: setColumns,
            dataSource: data,
            setDataSource: setData,
            readOnly: readOnly,
            setReadOnly: setReadOnly,
            modalExcel: modalExcel,
            setModalExcel: setModalExcel,
        }
    };
    let presenter = new TableByProjectPresenter(view);
    useEffect(() => {presenter.switchView()},[]);
    useEffect(() => {
        if (Utilities.isNullObject(presenter.basicFields)) { presenter.getAllColumnsDefinitions(); }
        if (!Utilities.isNullObject(presenter.basicFields) && !Utilities.isNullObject(presenter.formMasters)) { presenter.initializeColumns(); }
    }, [
        presenter.basicFields,
        presenter.formMasters
    ])

    useEffect(() => {
        presenter.renderTableWithData(columns);
    }, [
        presenter.getCurrentData,
        presenter.formMasters
    ])

    return (
        <div>
            <AEABatchGrid
                modalExcel={modalExcel}
                gridDataExcel={columns}
                RegionCountry={presenter?.currentBudget?.RegionCountry}
                formMasters={presenter.formMasters}
                presenter={presenter}
                onRowInserted={presenter.onAddNewRow}
                columns={columns}
                dataSource={data}
                gridProps={presenter.getGridProps()}
                onCellPreRender={presenter.onCellPreRender}
                summaryRows={presenter.summaryConfig}    
                readOnly={readOnly}     
            ></AEABatchGrid> 
        </div>
    )

}

export default FormBudgetDetailTableByProject;